import React from 'react'
import {
  Box,
  Typography
} from '@mui/material';

const EmailTemplate = () => {
  return (
    <>
          <Box className="headingBtnWrap">
            <Typography variant="h1">Email Template</Typography>
          </Box>
        </>
  )
}

export default EmailTemplate
